<ion-header class="coupon-card-modal__header">
  <shared-close (tap)="modal.dismiss(null)"></shared-close>
</ion-header>
<ion-content padding>
  <shared-v2-coupon-card [ticketSelected]="ticketSelected" [isCouponLocked]="!ticketSelected?.unlocked"
    [showRegisterButton]="!user?.getUser()?.isRegistered && showRegisterButton"
    [isCouponRegisterMandatory]="registerMandatory" (activateEvent)="activate($event)" (redeemEvent)="redeem($event)">
  </shared-v2-coupon-card>
</ion-content>